module.exports = __webpack_public_path__ + "static/neufile-grotesk-regular-11969c8f345eec34eb5ab859d307cfe2.woff";